import React from 'react'
import { IconToggleOutline } from '@/components/icons'
import { FormContentV2 } from './FormComponent/FormContentV2'
import { InferFormValues, JsonFormSchemaV2 } from './FormComponent/types'
import { cn } from '@/lib/utils'

interface TileFilterProps {
  schema?: JsonFormSchemaV2
  submitHandler?: (data: InferFormValues<JsonFormSchemaV2>) => void
  className?: string
}

export function TileFilter({ schema, submitHandler, className }: TileFilterProps) {
  if (!schema?.properties || !submitHandler) return null
  return (
    <div className={cn('flex items-center gap-4 rounded-md border bg-background pr-4', className)}>
      <div className="flex items-center justify-center self-stretch border-r bg-grey-lighterer px-2 text-muted-foreground">
        <IconToggleOutline size={18} />
      </div>
      <FormContentV2 variant="row" filterType="tile" schema={schema} submitHandler={submitHandler} />
    </div>
  )
}
